import React from 'react';
import { PredefinedColors } from '@ionic/core';
import { IonButton } from '@ionic/react';
import './Button.css';
import clsx from 'clsx';

export interface ButtonProps {
  isSubmit?: boolean;
  fullWidth?: boolean;
  className?: string;
  color?: PredefinedColors;
  small?: boolean;
  onClick?: (e?) => void;
  secondary?: boolean;
  fill?: 'clear' | 'outline' | 'solid' | 'default';
  slot?: string;
  id?: string;
  routerLink?: string;
  title?: string;
  children: React.ReactNode;
  round?: boolean;
  disabled?: boolean;
  /** Extra `data-*` attributes, e.g. stable anchors for the in-app guide. */
  dataAttributes?: Record<string, string>;
}

const Button = ({
  fullWidth = false,
  color,
  secondary,
  fill,
  small,
  onClick,
  slot,
  className,
  isSubmit = false,
  id,
  routerLink,
  title,
  children,
  round = true,
  disabled = false,
  dataAttributes,
}: ButtonProps) => (
  <IonButton
    {...dataAttributes}
    routerLink={routerLink}
    {...(!small && round && { shape: 'round' })}
    {...(id && { id })}
    color={secondary ? 'tertiary' : color}
    onClick={onClick}
    {...(slot && { slot })}
    {...(fill && { fill })}
    {...(title && { title })}
    className={clsx('button', className, small && 'small')}
    expand={fullWidth ? 'block' : undefined}
    type={isSubmit ? 'submit' : undefined}
    disabled={disabled}
  >
    {children}
  </IonButton>
);

export default Button;
